import React from "react";
import Heading from "./Heading";

export default function About() {
  return <Heading transkey="common.error" />;
}
